module.exports = __webpack_public_path__ + "img/projek-pwa.1b461d49.png";